<section class="faq" [class.light]="isLight" [class.floatless]="noFloat">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8 m-auto">
                <h1>Frequently Asked <br /> Questions</h1>

                <div class="accordion">
                    <div class="faq-card" *ngFor="let faq of faqs; let i = index">
                        <h4 [id]="'general-accord-l' + i" (click)="openAccordion('general-accord-l' + i)">
                            <span>{{faq.title}}</span>
                            <fa-icon [icon]="icons.plus" class="black"></fa-icon>
                        </h4>
                        <div [innerHTML]="faq.content"></div>
                    </div>
                    </div>
            </div>
        </div>
    </div>
</section>